// JS
import '../../custom/js/index';
import '../../custom/js/components/modal/video-modal';
import '../../custom/js/components/accordion.js';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Components SCSS
import '../../custom/scss/components/hero/hero.scss';
import '../../custom/scss/components/service-cards/service-cards.scss';
import '../../custom/scss/components/home/enrichment-cards.scss';
import '../../custom/scss/components/home/number-cards.scss';
import '../../custom/scss/components/home/cta-section.scss';
import '../../custom/scss/components/hero/video-hero.scss';
import '../../custom/scss/components/cta/cta.scss';
import '../../custom/scss/components/faq/faq.scss';
import '../../custom/scss/components/accordion/accordion.scss';
import '../../custom/scss/components/modal/modal.scss';